// @react/hooks/usePlatform.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { platformStore } from '@core/stores';

/**
 * React hook for Platform operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { usePlatform } from '@react/hooks';
 *
 * const PlatformList = observer(() => {
 *   const store = usePlatform();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function usePlatform() {
  return platformStore;
}
